import { render, staticRenderFns } from "./codebook.vue?vue&type=template&id=44f62dc1&scoped=true"
import script from "./codebook.vue?vue&type=script&lang=js"
export * from "./codebook.vue?vue&type=script&lang=js"
import style0 from "./codebook.vue?vue&type=style&index=0&id=44f62dc1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44f62dc1",
  null
  
)

export default component.exports